import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarCheck, faChartLine, faSync } from "@fortawesome/free-solid-svg-icons";
import { Col, Row, Card, Container, Button } from '@themesberg/react-bootstrap';
import { useHistory } from 'react-router-dom';
import AttendanceCalendar from '../components/AttendanceCalendar';
import { formatDateShort } from '../utils/dateUtils';
import { useDashboard } from '../hooks';
import { Routes } from '../routes';
import Breadcrumbs from '../components/Breadcrumbs';
import {
  AttendanceModal,
  EventDetailModal
} from '../components/modals';

export default () => {
  const history = useHistory();
  const {
    user,
    events,
    attendance,
    reports,
    modals,
    utils,
    meetSync,
    handleEventSelect,
    handleShowAttendance,
    handleTabSelect,
    handleCopyLink,
    handleDownloadQR,
    handleSyncMeet,
    handleResyncMeet,
    handleRefreshMeetStatus
  } = useDashboard();
  
  const handleShowReports = () => {
    history.push(Routes.Reports.path);
  };





  const handleViewEventReport = async (format) => {
    // Obtener el ID de la base de datos del evento
    const eventDbId = await events.getEventDbId(events.selectedEvent.id, events.selectedEvent);
    const eventTitle = events.selectedEvent?.title || events.selectedEvent?.summary || 'Evento sin título';
    if (format === 'html') {
      reports.viewHTMLReport(eventDbId, eventTitle);
    } else {
      reports.viewJSONReport(eventDbId);
    }
  };

  const handleDownloadEventReport = async (format) => {
    // Obtener el ID de la base de datos del evento
    const eventDbId = await events.getEventDbId(events.selectedEvent.id, events.selectedEvent);
    const eventTitle = events.selectedEvent?.title || events.selectedEvent?.summary || 'Evento';
    reports.downloadReport(eventDbId, format, eventTitle);
  };
  
  // Función personalizada para todos los invitados
  const handleDownloadEventReportCustom = async (format, soloAsistentes = true) => {
    const eventDbId = await events.getEventDbId(events.selectedEvent.id, events.selectedEvent);
    const eventTitle = events.selectedEvent?.title || events.selectedEvent?.summary || 'Evento';
    
    if (soloAsistentes) {
      reports.downloadReport(eventDbId, format, eventTitle);
    } else {
      const url = `/eventos/${eventDbId}/reporte/descargar/${format}/?solo_asistentes=false`;
      reports.downloadReportCustom(url, eventTitle, format);
    }
  };
  
  // Agregar la función personalizada como propiedad
  handleDownloadEventReport.custom = handleDownloadEventReportCustom;
  return (
    <Container fluid className="px-4">
      <Row className="justify-content-md-center">
        <Col xs={12}>
          <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
            <div className="d-block mb-4 mb-md-0">
              <Breadcrumbs />
              <h2 className="h4">Control de Asistencia</h2>
              <p className="mb-0">Resumen general del sistema de asistencia</p>
            </div>
          </div>
        </Col>
      </Row>

      <Row className="mb-3">


        <Col xs={12} sm={6} xl={4} className="mb-4">
          <Card className="text-white" style={{ cursor: 'pointer', backgroundColor: '#844E98' }} onClick={handleShowReports}>
            <Card.Body>
              <div className="d-flex align-items-center">
                <div className="icon icon-shape icon-md bg-white rounded me-4" style={{ color: '#844E98' }}>
                  <FontAwesomeIcon icon={faChartLine} />
                </div>
                <div>
                  <span className="h6 text-white mb-0">Reportes de</span>
                  <h3 className="fw-bold text-white">Asistencia</h3>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col xs={12} xl={8} className="d-flex justify-content-end align-items-center">
          <span className="me-2 text-muted" style={{ fontSize: '16px', fontFamily: 'Roboto, sans-serif' }}>Actualizar eventos disponibles</span>
          <Button variant="outline-primary" onClick={utils.refreshEvents} size="lg">
            <FontAwesomeIcon icon={faSync} />
          </Button>
        </Col>
      </Row>

      <Row>
        <Col xs={12} className="mb-4">
          <AttendanceCalendar key={utils.refreshKey} onEventSelect={handleEventSelect} />
        </Col>
      </Row>



      {/* Modales */}

      <AttendanceModal
        show={modals.showAttendanceModal}
        onHide={modals.closeAttendanceModal}
        user={user}
        events={events.userEvents || events.events}
        loading={events.loading}
        error={events.error}
      />

      <EventDetailModal
        show={modals.showEventDetailModal}
        onHide={modals.closeEventDetailModal}
        selectedEvent={events.selectedEvent}
        activeTab={modals.activeTab}
        onTabSelect={handleTabSelect}
        validatingGuests={attendance.validatingGuests}
        generatingAttendance={attendance.generatingAttendance}
        validationResult={attendance.validationResult}
        attendanceQR={attendance.attendanceQR}
        attendanceLink={attendance.attendanceLink}
        loadingReports={reports.loadingReports}
        error={attendance.error || reports.error}
        htmlContent={reports.htmlContent}
        onViewEventReport={handleViewEventReport}
        onDownloadEventReport={handleDownloadEventReport}
        onDownloadQR={handleDownloadQR}
        onCopyLink={handleCopyLink}
        meetStatus={meetSync.meetStatus}
        loadingMeetStatus={meetSync.loadingStatus}
        syncingMeet={meetSync.syncing}
        meetSyncResult={meetSync.syncResult}
        meetError={meetSync.error}
        onSyncMeet={handleSyncMeet}
        onResyncMeet={handleResyncMeet}
        onRefreshMeetStatus={handleRefreshMeetStatus}
      />




    </Container>
  );
};